import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = [{
  title: 'LAS 25 RECETAS ANTI-ANTOJO COMPLETAS',
  desc: 'Organizadas por tipo: Dulce / Salado / Crunch. Con ingredientes, pasos y ciencia detrás de cada una.',
  value: 27
}, {
  title: 'GUÍA DE LOS 3 DISPARADORES DEL ANTOJO',
  desc: 'Aprende a identificar qué dispara TU antojo y cómo neutralizarlo antes de que gane.',
  value: 12
}, {
  title: 'PLAN DE SNACKS DE 7 DÍAS LISTO PARA USAR',
  desc: 'Exactamente qué comer, cuándo y por qué. Sin pensar. Sin decidir. Solo ejecutar.',
  value: 15
}, {
  title: 'LISTA DE COMPRAS SEMANAL INTELIGENTE',
  desc: 'Todo lo que necesitas en una sola lista. Organizada por sección del supermercado.',
  value: 7
}, {
  title: 'TABLA DE SUSTITUCIONES COMPLETA',
  desc: '¿Sin gluten? ¿Vegana? ¿Sin lactosa? Cada receta tiene su versión adaptada.',
  value: 10
}, {
  title: 'GUÍA DE MEAL PREP DE SNACKS',
  desc: 'Cómo preparar todos tus snacks en 30 minutos el domingo para tener la semana resuelta.',
  value: 12
}];
export function ValueStack() {
  return <section className="py-24 px-4 bg-brand-cream text-brand-darkText" data-id="element-293">
      <div className="max-w-4xl mx-auto" data-id="element-294">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-295">
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-brand-dark mb-4" data-id="element-296">
            TODO LO QUE OBTIENES HOY
          </h2>
        </motion.div>

        <div className="bg-white rounded-3xl shadow-xl border border-brand-gold/30 overflow-hidden" data-id="element-297">
          <div className="p-8 md:p-12 space-y-6" data-id="element-298">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-4 pb-6 border-b border-brand-light/10 last:border-0 last:pb-0" data-id="element-299">
                <div className="mt-1 bg-brand-light/20 p-1 rounded-full h-fit" data-id="element-300">
                  <Check className="w-5 h-5 text-brand-medium" data-id="element-301" />
                </div>
                <div className="flex-1" data-id="element-302">
                  <h3 className="font-bold text-brand-dark text-lg mb-1" data-id="element-303">
                    {item.title}
                  </h3>
                  <p className="text-brand-dark/70 text-sm md:text-base" data-id="element-304">
                    {item.desc}
                  </p>
                </div>
                <div className="text-right font-bold text-brand-medium/60" data-id="element-305">
                  Valor: ${item.value}
                </div>
              </motion.div>)}
          </div>

          <div className="bg-brand-dark text-brand-cream p-8 md:p-12 text-center relative overflow-hidden" data-id="element-306">
            <div className="absolute inset-0 bg-gold-gradient opacity-10" data-id="element-307" />
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16" data-id="element-308">
              <div data-id="element-309">
                <p className="text-brand-cream/70 text-lg mb-1" data-id="element-310">VALOR TOTAL:</p>
                <p className="text-3xl font-bold line-through text-brand-cream/50" data-id="element-311">
                  $83
                </p>
              </div>
              <div className="hidden md:block w-px h-16 bg-brand-gold/30" data-id="element-312" />
              <div data-id="element-313">
                <p className="text-brand-lightGold text-lg mb-1 font-semibold" data-id="element-314">
                  TU INVERSIÓN HOY:
                </p>
                <p className="text-5xl md:text-6xl font-bold font-heading text-brand-gold" data-id="element-315">
                  $6.36
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}